<template>
  <Content class="statistics-page">
    <Card>
      <div slot="title">
        <span>数据统计与分析</span>
        <Button 
          type="primary" 
          icon="ios-download-outline" 
          style="float: right;"
          @click="exportReport"
        >
          导出报表
        </Button>
      </div>

      <!-- 时间范围选择 -->
      <div class="time-range-selector" style="margin-bottom: 16px;">
        <ButtonGroup>
          <Button 
            v-for="range in timeRanges" 
            :key="range.key"
            :type="selectedTimeRange === range.key ? 'primary' : 'default'"
            @click="selectTimeRange(range.key)"
          >
            {{ range.label }}
          </Button>
        </ButtonGroup>
        <DatePicker 
          v-model="customDateRange" 
          type="daterange" 
          format="yyyy-MM-dd"
          placeholder="自定义日期范围"
          style="width: 250px; margin-left: 16px;"
          @on-change="onCustomDateChange"
        />
      </div>

      <!-- 统计Tab -->
      <Tabs v-model="activeTab" @on-click="onTabChange">
        <TabPane label="订单统计" name="order">
          <OrderStatistics ref="orderStats" :date-range="dateRange" />
        </TabPane>
        <TabPane label="收入统计" name="revenue">
          <RevenueStatistics ref="revenueStats" :date-range="dateRange" />
        </TabPane>
        <TabPane label="用户统计" name="user">
          <UserStatistics ref="userStats" :date-range="dateRange" />
        </TabPane>
        <TabPane label="车辆统计" name="car">
          <CarStatistics ref="carStats" :date-range="dateRange" />
        </TabPane>
        <TabPane label="商品统计" name="goods">
          <GoodsStatistics ref="goodsStats" :date-range="dateRange" />
        </TabPane>
      </Tabs>
    </Card>
  </Content>
</template>

<script>
import OrderStatistics from './components/OrderStatistics.vue'
import RevenueStatistics from './components/RevenueStatistics.vue'
import UserStatistics from './components/UserStatistics.vue'
import CarStatistics from './components/CarStatistics.vue'
import GoodsStatistics from './components/GoodsStatistics.vue'
import { exportStatisticsReport } from '@/api/statistics'

export default {
  name: 'Statistics',
  components: {
    OrderStatistics,
    RevenueStatistics,
    UserStatistics,
    CarStatistics,
    GoodsStatistics
  },
  data() {
    return {
      activeTab: 'order',
      selectedTimeRange: '7days',
      customDateRange: [],
      timeRanges: [
        { key: 'today', label: '今日' },
        { key: '7days', label: '近7天' },
        { key: '30days', label: '近30天' },
        { key: '90days', label: '近90天' },
        { key: 'year', label: '本年度' }
      ]
    }
  },
  computed: {
    dateRange() {
      const now = new Date()
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
      let start = new Date()

      switch (this.selectedTimeRange) {
        case 'today':
          start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
          break
        case '7days':
          start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
          break
        case '30days':
          start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)
          break
        case '90days':
          start = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000)
          break
        case 'year':
          start = new Date(now.getFullYear(), 0, 1, 0, 0, 0)
          break
        case 'custom':
          if (this.customDateRange && this.customDateRange.length === 2) {
            return this.customDateRange
          }
          break
        default:
          start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
      }

      return [start, end]
    }
  },
  methods: {
    selectTimeRange(key) {
      this.selectedTimeRange = key
      this.refreshCurrentTab()
    },
    onCustomDateChange(dateRange) {
      if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        this.selectedTimeRange = 'custom'
        this.refreshCurrentTab()
      }
    },
    onTabChange() {
      this.refreshCurrentTab()
    },
    refreshCurrentTab() {
      this.$nextTick(() => {
        const refName = this.activeTab + 'Stats'
        if (this.$refs[refName] && this.$refs[refName].loadData) {
          this.$refs[refName].loadData()
        }
      })
    },
    async exportReport() {
      try {
        this.$Message.loading({
          content: '正在生成报表...',
          duration: 0
        })

        const params = {
          type: this.activeTab,
          startDate: this.dateRange[0],
          endDate: this.dateRange[1],
          format: 'excel'
        }

        const res = await exportStatisticsReport(params)
        
        // 创建下载链接
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${this.getReportName()}_${new Date().toISOString().slice(0, 10)}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)

        this.$Message.destroy()
        this.$Message.success('报表导出成功')
      } catch (error) {
        this.$Message.destroy()
        this.$Message.error('报表导出失败')
        console.error(error)
      }
    },
    getReportName() {
      const names = {
        order: '订单统计报表',
        revenue: '收入统计报表',
        user: '用户统计报表',
        car: '车辆统计报表',
        goods: '商品统计报表'
      }
      return names[this.activeTab] || '统计报表'
    }
  },
  mounted() {
    this.refreshCurrentTab()
  }
}
</script>

<style lang="less" scoped>
.statistics-page {
  .time-range-selector {
    display: flex;
    align-items: center;
  }
}
</style>

